import gql from 'graphql-tag';

export const SensorsQuery = gql`
  query SensorsQuery(
    $limit:Int 
    $nextToken: String
  ) {
    sensors(
      limit: $limit
      nextToken: $nextToken
    ) {
      nextToken
      items{
        id
        name
        room
        lightsOnHighTemp
        lightsOnLowTemp
        lightsOffHighTemp
        lightsOffLowTemp
        tempTransitionPeriodLength
        luxLightsOnTarget
        luxLightsOffTarget
        luxThreshold
        lightsOn
        lightsOff
      }
    }
  }
`;

export const SensorQuery = gql`
  query SensorQuery(
    $id: ID!
  ) 
  {
    sensor( id: $id ) {
      id
      name
      room
      lightsOnHighTemp
      lightsOnLowTemp
      lightsOffHighTemp
      lightsOffLowTemp
      tempTransitionPeriodLength
      luxLightsOnTarget
      luxLightsOffTarget
      luxThreshold
      lightsOn
      lightsOff
    }
  }
`;

export default {
  SensorsQuery,
  SensorQuery
};


// WEBPACK FOOTER //
// ./src/queries/index.js